import { render, staticRenderFns } from "./DxMonitoringPoints.vue?vue&type=template&id=6aaadeb5&"
import script from "./DxMonitoringPoints.vue?vue&type=script&lang=js&"
export * from "./DxMonitoringPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports